import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

const BLOCK = "#9b958b";
const BLOCK_SEAM = "#6f6a61";

function blockUnit(cx: number, cy: number, cz: number, s: number): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(s, s * 0.7, s * 0.9), color: BLOCK, position: [cx, cy, cz] },
    { geometry: new THREE.BoxGeometry(s * 1.01, 0.01, s * 0.92), color: BLOCK_SEAM, position: [cx, cy + s * 0.36, cz] },
  ];
}

export const stoneBlock = defineModel({
  id: "stone-block",
  batchId: "characters",
  name: "Stone block",
  tags: ["good", "cargo", "stone"],
  fits: ["carry"],
  summary: "A dressed stone block -- a carriable good for an avatar's carry socket.",
  description:
    "A single dressed stone block at held scale, ported from age-of-mcp's goods " +
    "(`block`). Mount it in a player's or worker's `carry` socket to show the " +
    "figure hauling cut stone.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: (): Part[] => blockUnit(0, 0.05, 0.02, 0.1),
  animations: [],
});
